interface Props {
  value: number;
  onChange: (fps: number) => void;
}

const OPTIONS = [1, 2, 4, 8, 10, 12, 16, 20, 30];

export function FpsSelect({ value, onChange }: Props) {
  return (
    <label className="inline-flex items-center gap-2 text-sm text-surface-300">
      <span>FPS</span>
      <select
        className="bg-surface-800 border border-surface-600 rounded-md px-2 py-1 text-sm"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      >
        {OPTIONS.map((f) => (
          <option key={f} value={f}>
            {f}
          </option>
        ))}
      </select>
    </label>
  );
}
